import {html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import defaultStyle from '../../../b2b-public-styles.scss';
import B2bPublicServiceClientProxy
  from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';

@customElement('b2b-public-mfalink')
export class B2bPublicMfalink extends B2bElement {
  static styles = [defaultStyle];

  /** @type {String} */
  @state()
  accessor __code;

  @property({type: Object, attribute: false})
  accessor route;

  @state()
  accessor __message;

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  render() {
    return html`
      <mta-page-lit page-name="mfalink" title="MFA Code Verification"></mta-page-lit>
      <div class="no-account">
        <h1>${this.__message}</h1>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.__code = this.route.args.code;
    this.isValid = this.__b2bPublicServiceProxy.verifyMfaCode(this.__code);

    // this.isValid.then(
    //     () => {
    //       this.__message = 'Multi-Factor Authentication Validated';
    //       setTimeout(() => {
    //         this.__b2bPublicServiceProxy.redirectToAppUrl()
    //           .then(url => {
    //             if (url !== null) {
    //               window.location.replace(url);
    //               if (!url.startsWith("https")) { // /oauth2/authorize uri
    //                 window.location.reload();
    //               }
    //             } else {
    //               this.redirect('#/home');
    //               window.location.reload();
    //             }
    //           });
    //       }, 3000);
    //     }).catch(
    //     () => {
    //       this.__message = 'Invalid link. Please try to reconnect';
    //       setTimeout(() => {
    //         this.redirect('#/auth/login');
    //       }, 3000);
    //     });
  }
}
